import React from "react"
import PropTypes from "prop-types"

const Form = ({ name }) => (
  <form name={name} method="POST" data-netlify="true">   
    <label className="block">
      <label htmlFor="name" className="text-black sr-only">Name</label>
      <input 
        type="text"
        name="name"
        className="form-input p-3 mb-5 block w-full"
        placeholder="Name"
      />
    </label>

    <label className="block">
      <label htmlFor="phone" className="text-black sr-only">Phone Number</label>
      <input
        type="tel"
        name="phone"
        className="form-input p-3 mb-5 block w-full"
        placeholder="Your Phone Number"
      />
    </label>

    <label className="block">
      <label htmlFor="email" className="text-black sr-only">Email Address</label>
      <input
        type="email"
        name="email"
        className="form-input p-3 mb-5 block w-full"
        placeholder="Email Address"
      />
    </label>

    <label className="block">
      <label htmlFor="postcode" className="text-black sr-only">Postcode</label>
      <input
        type="input"
        name="postcode"
        className="form-input p-3 mb-5 block w-full"
        placeholder="Your Postcode"
      />
    </label>

    <label className="block">
      <label htmlFor="size" className="text-black sr-only">Size</label>
      <input
        type="input"
        name="size"
        className="form-input p-3 mb-5 block w-full"
        placeholder="Skip Size"
      />
    </label>

    <div className="text-center">
      <button type="submit" className="btn block w-full">Get a Quote</button>
    </div>
  </form>
)

Form.propTypes = {
  name: PropTypes.string
}

Form.defaultProps = {
  name: ``
}

export default Form